<template lang="pug">
footer.front
  .container
    .col-md-6.col-xs-12
      p.copyright {{ $t("footer.copyright") }}
    .col-md-6.col-xs-12
      p.policy
        a.link(@click="onTerms") {{ $t("footer.terms_of_use") }}
        a.link(@click="onPolicy") {{ $t("footer.policy") }}
    .clearfix
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
  methods: {
    onTerms() {
      this.$router.push({name: 'terms_of_use'})
    },
    onPolicy() {
      this.$router.push({name: 'policy'})
    }
  }
}
</script>
<style lang="scss">
footer.front{background:#23180A; 
  .copyright{color: #FFFFFF;  margin:0; padding:0 !important;}
  .policy{margin:0; padding:0 !important; text-align:right;
    a.link{color: #FFFFFF;margin-right: 30px; cursor: pointer;text-decoration: underline;}
    a.link:last-child{margin-right:0;}
  }
}
@media (max-width: 991px){
  footer.front{
    .copyright{text-align:center;}
    .policy{text-align:center;}
  }
}
@media (max-width: 375px){
  footer.front{
    .policy{
      a.link{margin-right: 15px;}
    }
  }
}
</style>




// WEBPACK FOOTER //
// index.vue?ed631d7e